import React, { forwardRef } from 'react';
import TextField from '@mui/material/TextField';
import { Box, FormHelperText, Paper } from '@mui/material';
import { useFormContext } from 'react-hook-form';
import { useEntityPermission } from '../../providers/EntityPermissionProvider/index';
import ReadOnly from './ReadOnly';

const isValidJson = value => {
  try {
    JSON.parse(value);
    return true;
  } catch {
    return false;
  }
};

const TextArea = forwardRef(
  ({ error, helperText, overwriteProps = {}, ...props }, ref) => {
    const { getValues } = useFormContext();
    const { isHidden, isReadOnly } = useEntityPermission();

    const currentvalue = getValues(props?.name);

    if (isReadOnly(props?.permission, currentvalue)) {
      return (
        <ReadOnly name={props?.name} component="div">
          {isValidJson(currentvalue) ? (
            <Paper variant="outlined" sx={{ overflow: 'hidden' }}>
              <Box
                component="pre"
                sx={{
                  m: 0,
                  p: 1,
                  maxHeight: 'min(40vh, 300px)',
                  overflow: 'auto',
                  fontSize: theme => theme.typography.caption.fontSize,
                  fontFamily: 'ui-monospace, monospace',
                }}>
                {currentvalue}
              </Box>
            </Paper>
          ) : (
            currentvalue
          )}
        </ReadOnly>
      );
    }

    if (isHidden(props?.permission)) {
      return <input type="hidden" name={props?.name} value={currentvalue} />;
    }
    return (
      <>
        <TextField
          sx={{
            '& .MuiInputBase-multiline': {
              padding: '6px 10px',
            },
          }}
          {...props}
          ref={ref}
          multiline
          rows={props.rows || 4}
          variant="outlined"
          fullWidth
          error={!!error}
          helperText={helperText}
          {...overwriteProps}
        />
        {error || helperText ? (
          <FormHelperText sx={{ typography: 'body2' }} error={Boolean(error)}>
            {error || helperText}
          </FormHelperText>
        ) : null}
      </>
    );
  },
);

export default TextArea;
